@if (heading(); as heading) {
  <onyx-information-heading>
    {{ heading | translate }}

    <onyx-link subheading color="gray" (click)="openDelegationModal.emit()">
      {{ identifier() }}
    </onyx-link>

    <ng-container actions>
      @if (isActive()) {
        <onyx-icon-button
          variant="transparent"
          color="gray"
          [size]="32"
          icon="check-outlined"
          [circle]="true"
          [disabled]="!!relatedFleetSwap()"
          [onyxTooltip]="
            relatedFleetSwap()
              ? 'labels.disabledUntilSwapCompleted'
              : 'labels.finishDelegation'
          "
          (click)="
            !relatedFleetSwap() ? openDelegationActionModal.emit() : null;
            $event.stopPropagation()
          "
        ></onyx-icon-button>
      }

      @if (hasEdit()) {
        <onyx-icon-button
          variant="transparent"
          color="gray"
          [size]="32"
          icon="edit-outlined"
          [circle]="true"
          [onyxTooltip]="`${I18N}.editDelegation`"
          (click)="edit.emit(); $event.stopPropagation()"
        ></onyx-icon-button>
      }
    </ng-container>
  </onyx-information-heading>
}

<div
  class="delegation-period"
  [class.clickable]="clickable()"
  tabindex="0"
  (click)="openDelegationModal.emit(); $event.stopPropagation()"
  (keydown.space)="openDelegationModal.emit(); $event.stopPropagation()"
>
  <div class="period-item">
    <div class="details">
      <div [class]="isPlanned() ? 'icon-box' : 'icon-box gray'">
        <onyx-icon
          [class]="isPlanned() ? 'blue' : 'white'"
          [name]="getIconName(start().address)"
          [size]="20"
        ></onyx-icon>

        <div class="icon-dot-container">
          <onyx-icon
            [name]="isPlanned() ? 'clock-filled' : 'check-circle-filled'"
            [size]="16"
            class="gray"
          ></onyx-icon>
        </div>
      </div>

      <div class="address">
        <onyx-address
          class="f-body-l f-semibold"
          [address]="start().address"
          format="city-flag"
          [onyxTooltip]="startAddressLabel()"
        ></onyx-address>

        <div class="caption f-body-xs f-muted">
          {{ `${I18N}.delegationStart` | translate }}

          <ng-container
            *ngTemplateOutlet="
              pointNameTemplate;
              context: { point: start().address }
            "
          ></ng-container>
        </div>
      </div>
    </div>

    <div
      class="date f-body-s f-semibold"
      [innerHTML]="
        `${start().date}T${start().time}`
          | onyxDate: 'time-day-date' : { separator: ' · ', showSameYear: true }
      "
    ></div>
  </div>

  <div class="status">
    <onyx-icon
      class="separator"
      name="arrow-timeline-filled"
      [size]="12"
    ></onyx-icon>

    <div class="status-text f-muted">
      @if (isPlanned()) {
        {{ `${I18N}.delegationHasNotStarted` | translate }}
      } @else if (isActive()) {
        {{ `${I18N}.delegationIsActive` | translate }}
      } @else if (isFinished()) {
        {{ `${I18N}.delegationHasBeenFinished` | translate }}
      } @else if (isCanceled()) {
        {{ `${I18N}.delegationHasBeenCanceled` | translate }}
      }
    </div>
  </div>

  <div class="period-item">
    <div class="details">
      <div [class]="isPlanned() || isActive() ? 'icon-box' : 'icon-box gray'">
        <onyx-icon
          [class]="isPlanned() || isActive() ? 'blue' : 'white'"
          [name]="getIconName(end().address)"
          [size]="20"
        ></onyx-icon>

        <div class="icon-dot-container">
          <onyx-icon
            [name]="
              isPlanned() || isActive() ? 'clock-filled' : 'check-circle-filled'
            "
            [size]="16"
            class="gray"
          ></onyx-icon>
        </div>
      </div>

      @if (end().address || end().date || end().time) {
        <div class="address">
          @if (end().address; as address) {
            <onyx-address
              class="f-body-l f-semibold"
              [address]="address"
              format="city-flag"
              [onyxTooltip]="endAddressLabel()"
            ></onyx-address>

            <div class="caption f-body-xs f-muted">
              {{ `${I18N}.delegationEnd` | translate }}

              <ng-container
                *ngTemplateOutlet="
                  pointNameTemplate;
                  context: { point: end().address }
                "
              ></ng-container>
            </div>
          } @else {
            <ng-container
              *ngTemplateOutlet="
                editLinkTemplate;
                context: {
                  font: 'f-body-l f-semibold',
                  label: `${I18N}.setEndAddress`,
                  noDelegationLabel: 'labels.lack',
                }
              "
            ></ng-container>

            <ng-container
              *ngTemplateOutlet="delegationEndLabelTemplate"
            ></ng-container>
          }
        </div>
      } @else {
        <div class="address">
          <ng-container
            *ngTemplateOutlet="
              editLinkTemplate;
              context: {
                font: 'f-body-l f-semibold',
                label: `${I18N}.setEndAddress`,
                noDelegationLabel: 'labels.lack',
              }
            "
          ></ng-container>

          <ng-container
            *ngTemplateOutlet="delegationEndLabelTemplate"
          ></ng-container>
        </div>
      }
    </div>

    @if (end().date || end().time) {
      <div class="date f-body-s f-semibold">
        @if (end().time; as time) {
          {{ time | onyxTime }}
        } @else {
          <ng-container
            *ngTemplateOutlet="
              editLinkTemplate;
              context: {
                font: 'f-body-s f-semibold',
                label: 'labels.setTime',
                noDelegationLabel: '-',
              }
            "
          ></ng-container>
        }

        <span class="f-muted"> · </span>

        @if (end().date; as date) {
          <span>
            {{ date | onyxDate: 'day-date' : { showSameYear: true } }}
          </span>
        } @else {
          <ng-container
            *ngTemplateOutlet="
              editLinkTemplate;
              context: {
                font: 'f-body-s f-semibold',
                label: 'labels.setDate',
                noDelegationLabel: '-',
              }
            "
          ></ng-container>
        }
      </div>
    } @else {
      <div class="date f-body-s f-semibold">
        <ng-container
          *ngTemplateOutlet="
            editLinkTemplate;
            context: {
              font: 'f-body-s f-semibold',
              label: 'labels.setEndDate',
              noDelegationLabel: '-',
            }
          "
        ></ng-container>
      </div>
    }
  </div>
</div>

<ng-template #delegationEndLabelTemplate>
  <span class="f-body-xs f-muted">
    {{ `${I18N}.delegationEnd` | translate }}

    @if (!hasEdit()) {
      · {{ 'labels.lack' | translate }}
    }
  </span>
</ng-template>

<ng-template
  let-font="font"
  let-label="label"
  let-noDelegationLabel="noDelegationLabel"
  #editLinkTemplate
>
  @if (hasEdit()) {
    <onyx-link
      color="blue"
      [font]="font ?? 'f-body-m f-medium'"
      (click)="edit.emit(); $event.stopPropagation()"
    >
      {{ label | translate }}
    </onyx-link>
  } @else {
    <span [class]="font">
      {{ noDelegationLabel | translate }}
    </span>
  }
</ng-template>

<ng-template let-point="point" #pointNameTemplate>
  @if (getIconName(point) === 'home-filled') {
    · {{ `${I18N}.delegationPeriodForm.driverHome` | translate }}
  } @else if (getIconName(point) === 'base-filled') {
    · {{ 'labels.base' | translate }}
  } @else if (driverHomeAddress()) {
    · {{ 'labels.address' | translate }}
  }
</ng-template>
